import styled from "styled-components";
import { fluid } from "@/styles/utils/fluid";

export const ContactFaqWrapper = styled.div`
  width: 100%;
  border-top: 4px solid ${({ theme }) => theme.colors.onyx};
  border-bottom: 4px solid ${({ theme }) => theme.colors.onyx};
  p {
    padding: 0;
  }
`;

export const ContactFaqInner = styled.ul`
  width: auto;
  height: auto;
  list-style-type: none;
  padding: 0;
`;

export const ContactFaqItem = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.onyx};
  &:last-of-type {
    border-bottom: none;
  }
  margin-bottom: 0;
`;

export const ContactFaqItemHeader = styled.div`
  h3 {
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.colors.phillipineSilver};
  }
  svg {
    width: 2rem;
    height: auto;
    margin-left: auto;
  }
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
  `};
  cursor: pointer;
  user-select: none;
  position: relative;
  color: ${({ theme }) => theme.colors.phillipineSilver};
  h3 {
    transition: all 0.3s ease-in-out;
  }
  &:hover,
  &:hover h3 {
    color: ${({ theme }) => theme.colors.onyx};
  }
`;

export const ContactFaqItemContentWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  p {
    padding: 0;
  }
`;

export const ContactFaqItemContent = styled.div`
  padding: ${({ theme }) => `
    0
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
  `};
`;
